import React, { Suspense } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './i18n';
import { HelmetProvider } from 'react-helmet-async';
import './styles/bootstrap-custom.scss';
import 'react-toastify/dist/ReactToastify.css';
import './styles/index.scss';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { SocketProvider } from './contexts/SocketContext';
import { ToastContainer } from 'react-toastify';
import { reportWebVitalsToMatomo } from './utils/reportWebVitalsToMatomo';
import { registerChunkLoadRecovery } from './utils/chunkLoadRecovery';
import { registerServiceWorker } from './utils/registerServiceWorker';
import ChunkLoadErrorBoundary from './components/ChunkLoadErrorBoundary';

registerChunkLoadRecovery();
registerServiceWorker();
reportWebVitalsToMatomo();

const container = document.getElementById('root');

const app = (
  <React.StrictMode>
    <ChunkLoadErrorBoundary>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <HelmetProvider>
          <AuthProvider>
            <SocketProvider>
              <Suspense fallback={null}>
                <App />
              </Suspense>
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
            </SocketProvider>
          </AuthProvider>
        </HelmetProvider>
      </BrowserRouter>
    </ChunkLoadErrorBoundary>
  </React.StrictMode>
);

if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
